export default __webpack_public_path__ + "9347db5956a89b0bab38d3e610eee01d.gif";